<template>
  <div class="tabs">
    <div class="tabs__tab-container">
      <template v-for="tab in tabs">
        <a href="javascript:;"
          :class="`tabs__tab ${tab.isActive ? 'tabs__tab--active' : ''}`"
          :data-tab="tab.id"
          :key="tab.id"
          :data-property="tab.property"
          @click="selectTab">
            <template v-if="tab.iconName">
              <icon :name="tab.iconName" height="24"></icon>
            </template>
            <span>{{ tab.name }}</span>
        </a>
      </template>
    </div>
    <div class="tabs__content-container">
      <slot />
    </div>
  </div>
</template>

<script>
/* eslint no-param-reassign: ["error", { "props": false }] */
export default {
  name: 'tabs',
  props: ['type'],
  data () {
    return {
      tabs: [],
      activeId: 1
    }
  },
  created () {
    this.$bus.$on('selectTab', (tabProperty) => {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.property === tabProperty
      })
    })
  },
  mounted () {
    this.tabs = this.$children.filter(tab => tab.id !== undefined)
    this.activateTab(true)
  },
  updated () {
    this.activateTab()
  },
  methods: {
    selectTab (event) {
      this.$bus.$emit('disableButton')
      const tabProperty = event.target.getAttribute('data-property')
      this.activeId = event.target.getAttribute('data-tab')
      this.tabs.forEach((tab) => {
        tab.isActive = tab.id === this.activeId
        this.$nextTick(() => {
          const inputFields = this.$el.querySelectorAll('input[type="text"]')
          if (inputFields[0]) inputFields[0].focus()
        })
      })
      if (this.type === 'signature') {
        this.$store.commit('setActiveTab', { activeTabId: this.activeId, tabProperty })
      }
      this.$bus.$emit('tabsSelected', { type: tabProperty })
    },
    activateTab (activeFirstTab) {
      if (activeFirstTab === true) {
        this.tabs.forEach((tab, index) => {
          tab.isActive = index === 0
        })
      } else {
        this.tabs.forEach((tab) => {
          if (this.type === 'signature') {
            tab.isActive = this.$store.state.signatureToUse === tab.property
          }
          if (tab.hasInput) {
            this.$nextTick(() => {
              const inputFields = this.$el.querySelectorAll('input[type="text"]')
              if (inputFields[0]) inputFields[0].focus()
            })
          }
        })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .tabs
    margin-top: -$spacing-base
    line-height: initial
    &__tab-container
      @include clearfix
      overflow-x: auto
      overflow-y: hidden
      white-space: nowrap
    &__content-container
      @include clearfix
    &__tab
      text-decoration: none
      color: initial
      padding: 15px
      color: #444
      display: inline-block
      margin-bottom: -4px
      span,
      svg
        pointer-events: none
      svg
        float: left
      span
        margin-top: 3px
        float: left
      &--active
        border-bottom: 2px solid $color-main
  @media screen and (max-width: $screen-size-small)
    .tabs
      &__tab
        line-height: initial
        span
          display: none
          white-space: nowrap
        svg
          margin-right: 0
        &--active
          span
            display: inline-block
          svg
            margin-right: $spacing-small
</style>
